export default __webpack_public_path__ + "static/media/Tasks_round_icon.b636b80a.svg";